import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selectReadinessState = (state: RootState) => state.overlayV2.readiness;

export const selectDeviceTask = createSelector([selectReadinessState], (state) => state.device);
export const selectChronologyTask = createSelector([selectReadinessState], (state) => state.chronology);
export const selectMatchTimeTask = createSelector([selectReadinessState], (state) => state.matchTime);
export const selectAssetsTask = createSelector([selectReadinessState], (state) => state.assets);
export const selectTemplateTask = createSelector([selectReadinessState], (state) => state.template);
export const selectRetryToken = (state: RootState) => state.overlayV2.readiness.retryToken;
export const selectRetryAt = (state: RootState) => state.overlayV2.readiness.retryAt;
/** Табло этого матча уже выходило в эфир — чеклист ему больше не показываем. */
export const selectHasGoneLive = (state: RootState) => state.overlayV2.readiness.hasGoneLive;

/** Запланированный автоповтор упавшего шага. `undefined` — повтор не назначен. */
export const selectReadinessRetry = createSelector([selectReadinessState], (state) =>
  state.retryAt === undefined ? undefined : { attempt: state.attempt, retryAt: state.retryAt },
);
